import apiPartners from "@/services/api.partners";

const state = {
    allPartners: [],
    isLoadingAllPartners: false
}

export const mutationTypes = {
    allPartnersStart: '[partners] All Partners start',
    allPartnersSuccess: '[partners] All Partners success',
    allPartnersFailure: '[partners] All Partners failure',

    createdPartnerStart: '[partners] Created Partner start',
    createdPartnerSuccess: '[partners] Created Partner success',
    createdPartnerFailure: '[partners] Created Partner failure',

    updatedPartnerStart: '[partners] Created Partner start',
    updatedPartnerSuccess: '[partners] Created Partner success',
    updatedPartnerFailure: '[partners] Created Partner failure',
}

export const actionTypes = {
    findPartners: '[partners] Get all partners',
    createdPartner: '[partners] Created partner',
    updatedPartner: '[partners] Updated partner'
}

export const getterTypes = {
    allPartners: '[partners] All partners',
    isLoadingAllPartners: '[partners] Is loading all partners'
}

const getters = {
    [getterTypes.allPartners]: (state) => {
        return state.allPartners
    },
    [getterTypes.isLoadingAllPartners]: (state) => {
        return state.isLoadingAllPartners
    },
}

const mutations = {
    [mutationTypes.allPartnersStart](state) {
        state.isLoadingAllPartners = true
    },
    [mutationTypes.allPartnersSuccess](state, payload) {
        state.isLoadingAllPartners = false
        state.allPartners = payload
    },
    [mutationTypes.allPartnersFailure](state) {
        state.isLoadingAllPartners = false
    },
    [mutationTypes.createdPartnerStart](state) {
        state.isLoadingAllPartners = true
    },
    [mutationTypes.createdPartnerSuccess](state, payload) {
        state.isLoadingAllPartners = false
        state.allPartners = payload
    },
    [mutationTypes.createdPartnerFailure](state) {
        state.isLoadingAllPartners = false
    },
    [mutationTypes.updatedPartnerStart](state) {
        state.isLoadingAllPartners = true
    },
    [mutationTypes.updatedPartnerSuccess](state, payload) {
        state.isLoadingAllPartners = false
        state.allPartners = payload
    },
    [mutationTypes.updatedPartnerFailure](state) {
        state.isLoadingAllPartners = false
    },
}

const actions = {
    [actionTypes.findPartners](context) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.allPartnersStart)
            apiPartners
                .getAllPartners()
                .then((response) => {
                    context.commit(mutationTypes.allPartnersSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.allPartnersFailure, result.response.data)
                })
        })
    },
    [actionTypes.createdPartner](context, payload) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.createdPartnerStart)
            apiPartners
                .createdPartner(payload)
                .then((response) => {
                    context.commit(mutationTypes.createdPartnerSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.createdPartnerFailure, result.response.data)
                })
        })
    },
    [actionTypes.updatedPartner](context, payload) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.updatedPartnerStart)
            apiPartners
                .updatePartner(payload)
                .then((response) => {
                    context.commit(mutationTypes.updatedPartnerSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.updatedPartnerFailure, result.response.data)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations,
    getters,
}